import React from 'react'
import TrackerItem from './TrackerItem'
import Utb2bApi from '../../network/UtB2bApi'

export default function MovementNotificationItem({name, options, speed, ...props}) {
    let value = options[0] 
    if (speed !== null) {
        const notMovingIndex = Utb2bApi.notifyTrackerNotMovingOptions.indexOf(speed)
        if (notMovingIndex !== null ) {
            value = options[notMovingIndex] 
        }
    }
    return <TrackerItem name={name} value={value} {...props} />
}